import React, {useContext, useEffect, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import {Card} from "../../../../components/card/card.jsx";
import {useQuery} from "@tanstack/react-query";
import materialStorageService from "../../../../services/web/material-storage-service.js";
import ModalStorages from "./components/modal-storages.jsx";
import Requester from "./components/requester.jsx";
import CautionsList from "./components/cautions-list.jsx";
import Caution from "./components/caution.jsx";
import Devolution from "./components/devolution.jsx";
import Decrease from "./components/decrease.jsx";
import {MaterialMovementsContext} from "./material-movements.context.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaFileAlt, FaPlus, FaPrint} from "react-icons/fa";
import {navigateHook} from "../../../../hooks/use-navigate.js";

const MaterialMovements = () => {
    const navigate = navigateHook();
    const {isLoading, userSelected} = useContext(MaterialMovementsContext)
    const [title, setTitle] = useState("Guichê")
    const [storageSelected, setStorageSelected] = useState("")
    const [openModalStorages, setOpenModalStorages] = useState(false)

    const {data: storages, isLoading: isLoadingStorage, fetchStatus} = useQuery({
        queryKey: ['material-storage'],
        queryFn: () => materialStorageService.optionsByUser(),
    });

    useEffect(() => {
        if (fetchStatus === "idle") {
            if (storages.length === 1) {
                setStorageSelected(storages[0])
            } else {
                setOpenModalStorages(true)
            }
        }
    }, [fetchStatus, storages]);

    useEffect(() => {
        if (storageSelected) setTitle(`Guichê ${storageSelected.label}`)
    }, [storageSelected]);

    const openReport = () => {
        const storageName = encodeURIComponent(storageSelected?.label ?? "");
        navigate(`/reports/material_movements_info?userId=${userSelected?.value}&storageName=${storageName}`, true)
    }

    return (
        <>
            <Template isLoading={isLoading || isLoadingStorage}>
                <Template.Header>
                    <Template.Title>
                        {title}
                    </Template.Title>
                    <div className={"flex gap-4"}>
                        <Button onClick={() => setOpenModalStorages(true)}>
                            Alterar depósito
                        </Button>
                        <Button title="Imprimir" onClick={openReport} disabled={userSelected?.value === undefined}>
                            <FaPrint/>
                        </Button>
                    </div>
                </Template.Header>
                <Template.Body>
                    <Card>
                        <Card.Body>
                            <div className="grid grid-cols-12 gap-4">
                               <Requester/>
                                <div className="col-span-5 flex items-center justify-center">
                                    <Caution storageSelected={storageSelected}/>
                                    <Devolution storageSelected={storageSelected}/>
                                    <Decrease storageSelected={storageSelected} />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>

                    <CautionsList />

                </Template.Body>
            </Template>

            <ModalStorages
                open={openModalStorages}
                setOpen={setOpenModalStorages}
                storages={storages}
                setStorageSelected={setStorageSelected}
                storageSelected={storageSelected}
            />
        </>
    );
};

export default MaterialMovements;